import { Dialog, DialogContent, DialogActions, DialogTitle, MenuItem, TextField, Button, Box, IconButton, Card, CardMedia, CardActions, Snackbar, Alert, Grid } from '@mui/material';
import React, { useState, useEffect, useRef } from 'react'
import { app, database, storage } from '../../../firebaseConfig'
import { addDoc, collection, query, orderBy, onSnapshot } from 'firebase/firestore'
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage"
import CloseIcon from '@mui/icons-material/Close';
import testImg from '../../../assets/testImg.png'
import LoadingButton from '@mui/lab/LoadingButton';
import dateFormat, { masks } from "dateformat";

function AddChu({ open, onClose, list }) {
    const [code, setCode] = useState('')
    const [nom, setNom] = useState('')
    const [email, setEmail] = useState('')
    const [contact, setContact] = useState('')
    const [contact1, setContact1] = useState('')
    const [photo, setPhoto] = useState({})
    const [description, setDescription] = useState('')
    const [adresse, setAdresse] = useState('')
    const [region, setRegion] = useState(null)
    const [logo, setLogo] = useState({})
    const [regions, setRegions] = useState([])
    const [services, setServices] = useState([])
    const inputFileRef = useRef(null)
    const inputLogoRef = useRef(null)
    const [photoDisplay, setPhotoDisplay] = useState(null)
    const [logoDisplay, setLogoDisplay] = useState(null)
    const [loading, setLoading] = useState(false)
    const [errorData, setErrorData] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    useEffect(() => {
        const q = query(collection(database, 'region'), orderBy('nom', 'asc'))
        const servicesData = query(collection(database, 'service'), orderBy('nom_service', 'asc'))
        onSnapshot(q, (querySnapshot) => {
            setRegions(querySnapshot.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            })))
        })
        onSnapshot(servicesData, (querySnapshot) => {
            setServices(querySnapshot.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            })))
        })
    }, [])
    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setErrorData(false)
    }
    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)
        setErrorData(false)
        const listFilter = list.filter((elem) => {
            return elem.nom_chu.toLowerCase() == nom.toLocaleLowerCase()
        })
        if (code =='' ||nom == '' || email == '' || contact == '' || contact1 == '' || region == '' || region == null || !photo.name) {
            setErrorData(true)
            setErrorMessage('Veuillez remplir les champs obligatoires!')
            setLoading(false)
            return
        }
        if (listFilter.length > 0) {
            setErrorData(true)
            setErrorMessage('Centre hospitalier universitaire existe déjà à notre base de données!')
            setLoading(false)
            return
        }
        let type_img ="img"
        let type_logo ="logo"
        let urlImage = await uploadImage(photo,type_img)
        let logoImage=''
        if(logo.name){
            logoImage=await uploadImage(logo,type_logo)
        }
        try {
            const chu = await addDoc(collection(database, 'chu'), {
                code_chu:code,
                nom_chu: nom,
                email_chu: email,
                contact_chu: contact,
                contact1_chu: contact1,
                description_chu: description,
                region_id: region,
                photo_chu: urlImage,
                logo_chu:logoImage,
                adresse_chu:adresse
            })
            const chu_id = chu.id
            services.map(async (service) => {
                await addDoc(collection(database, 'service_chu'), {
                    chu_id: chu_id,
                    service_id: service.id,
                    status: false
                })
            })
            onClose()
            setLoading(false)
        } catch (err) {
            setLoading(false)
        }
    }
    const uploadImage = (fileParm,type) => {
        const nom_img = "chu_"+type+"_"+dateFormat(new Date(),'yyyymmddHHMMss')
        return new Promise((resolve, reject) => {
            const storageRef = ref(storage, nom_img)
            const uploadTask = uploadBytesResumable(storageRef, fileParm)
            uploadTask.on('state_changed', (snapshot) => {
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('Upload is ' + progress + '% done');
            },
                (error) => {
                    console.log(error.message)
                    reject(error);
                },
                () => {
                    getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                        console.log('File available at', downloadURL);
                        resolve(downloadURL);
                    }).catch((error) => {
                        console.log(error.message);
                        reject(error);
                    });
                }
            )
        })

    }
    const clickImage = (e) => {
        e.preventDefault()
        if (inputFileRef.current) {
            inputFileRef.current.click();
        }
    }
    const clickILogo = (e) => {
        e.preventDefault()
        if (inputLogoRef.current) {
            inputLogoRef.current.click();
        }
    }
    const changeImage = (e) => {
        const file = e.target.files[0]
        setPhoto(file)
        const reader = new FileReader();

        reader.onload = () => {
            setPhotoDisplay(reader.result);
        };

        reader.readAsDataURL(file);
    }
    const changeLogo = (e) => {
        const file = e.target.files[0]
        setLogo(file)
        const reader = new FileReader();
        reader.onload = () => {
            setLogoDisplay(reader.result);
        };

        reader.readAsDataURL(file);
    }


    return (
        <div>
            <Dialog
                open={open}
                onClose={onClose}
            >
                <DialogTitle sx={{ m: 0, p: 2 }}>Ajout une CHU</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <Box component="form"
                        noValidate
                        autoComplete="off">
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Card sx={{ mx: 2, maxWidth: 200 }}>
                                    <CardMedia
                                        style={{ objectFit: 'contain', marginTop: 1, height: 80 }}
                                        image={photoDisplay ? photoDisplay : testImg}
                                        title="green iguana"
                                    />
                                    <CardActions style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <Button size="small" onClick={clickImage}>Choisir une photo</Button>
                                    </CardActions>
                                </Card>
                            </Grid>
                            <Grid item xs={6}>
                                <Card sx={{ mx: 2, maxWidth: 200 }}>
                                    <CardMedia
                                        style={{ objectFit: 'contain', marginTop: 1, height: 80 }}
                                        image={logoDisplay ? logoDisplay : testImg}
                                        title="green iguana"
                                    />
                                    <CardActions style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <Button size="small" onClick={clickILogo}>Choisir un logo</Button>
                                    </CardActions>
                                </Card>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    autoFocus
                                    required
                                    margin="dense"
                                    id="code_chu"
                                    name="code_chu"
                                    label="Code du CHU"
                                    fullWidth
                                    onChange={(e) => {
                                        setCode(e.target.value)
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    size='small'
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    required
                                    margin="dense"
                                    id="nom_chu"
                                    name="nom_chu"
                                    label="Nom du CHU"
                                    fullWidth
                                    onChange={(e) => {
                                        setNom(e.target.value)
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    size='small'
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    required
                                    id="outlined-select-currency"
                                    select
                                    label="Province"
                                    defaultValue=""
                                    fullWidth
                                    onChange={(e) => {
                                        setRegion(e.target.value)
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    size='small'
                                >
                                    <MenuItem key=" " value="">
                                        Veuillez selectionner un région
                                    </MenuItem>
                                    {regions.map((region) => (
                                        <MenuItem key={region.id} value={region.id}>
                                            {region.data.nom}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    autoFocus
                                    required
                                    margin="dense"
                                    id="email"
                                    name="email"
                                    label="Email"
                                    fullWidth
                                    onChange={(e) => {
                                        setEmail(e.target.value)
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    size='small'
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    autoFocus
                                    required
                                    margin="dense"
                                    id="contact"
                                    name="contact"
                                    label="Contact"
                                    fullWidth
                                    onChange={(e) => {
                                        setContact(e.target.value)
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    size='small'
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    autoFocus
                                    required
                                    margin="dense"
                                    id="contact1"
                                    name="contact1"
                                    label="Contact1"
                                    fullWidth
                                    onChange={(e) => {
                                        setContact1(e.target.value)
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    size='small'
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    autoFocus
                                    required
                                    margin="dense"
                                    id="adresse"
                                    name="adresse"
                                    label="Adresse"
                                    fullWidth
                                    onChange={(e) => {
                                        setAdresse(e.target.value)
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    size='small'
                                />
                            </Grid>
                            <Grid item xs={6}><TextField
                                autoFocus
                                required
                                margin="dense"
                                id="description"
                                name="description"
                                label="Description"
                                fullWidth
                                onChange={(e) => {
                                    setDescription(e.target.value)
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                size='small'
                            />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    autoFocus
                                    required
                                    margin="dense"
                                    id="Image"
                                    name="image"
                                    label="Image"
                                    fullWidth
                                    onChange={changeImage}
                                    type='file'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    style={{ display: 'none' }}
                                    inputRef={inputFileRef}
                                    size='small'
                                />
                                <TextField
                                    autoFocus
                                    required
                                    margin="dense"
                                    id="logo"
                                    name="logo"
                                    label="Image"
                                    fullWidth
                                    onChange={changeLogo}
                                    type='file'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    style={{ display: 'none' }}
                                    inputRef={inputLogoRef}
                                    size='small'

                                />
                            </Grid>
                        </Grid>

                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Annuler</Button>
                    <LoadingButton loading={loading} loadingIndicator="Envoie…" onClick={handleSubmit} variant='contained' color='success' >Enregistrer</LoadingButton>
                </DialogActions>
                <Snackbar open={errorData} autoHideDuration={6000} onClose={handleCloseAlert} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                    <Alert
                        onClose={handleCloseAlert}
                        severity="error"
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        {errorMessage}
                    </Alert>
                </Snackbar>
            </Dialog>
        </div>
    )
}

export default AddChu